import { render, staticRenderFns } from "./ResellerAdd.vue?vue&type=template&id=4a7f556d&"
import script from "./ResellerAdd.vue?vue&type=script&lang=js&"
export * from "./ResellerAdd.vue?vue&type=script&lang=js&"
import style0 from "./ResellerAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports